import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cea645e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "bus-icon",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 48 48",
  style: {"enable-background":"new 0 0 48 48"},
  "xml:space": "preserve"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { id: "road" }, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("g", { class: "st0 lane-1" }, [
      /*#__PURE__*/_createElementVNode("polygon", {
        class: "st1",
        points: "43.7,35.7 40.5,35.7 47.6,43.7 52.3,43.4 \t\t\t"
      }),
      /*#__PURE__*/_createElementVNode("polygon", {
        class: "st1",
        points: "-4.3,43.4 0.4,43.7 7.5,35.7 4.3,35.7 \t\t\t"
      })
    ]),
    /*#__PURE__*/_createElementVNode("g", { class: "st0 lane-2" }, [
      /*#__PURE__*/_createElementVNode("polygon", {
        class: "st1",
        points: "43.7,35.7 40.5,35.7 47.6,43.7 52.3,43.4 \t\t\t"
      }),
      /*#__PURE__*/_createElementVNode("polygon", {
        class: "st1",
        points: "-4.3,43.4 0.4,43.7 7.5,35.7 4.3,35.7 \t\t\t"
      })
    ]),
    /*#__PURE__*/_createElementVNode("g", { class: "st0 lane-3" }, [
      /*#__PURE__*/_createElementVNode("polygon", {
        class: "st1",
        points: "43.7,35.7 40.5,35.7 47.6,43.7 52.3,43.4 \t\t\t"
      }),
      /*#__PURE__*/_createElementVNode("polygon", {
        class: "st1",
        points: "-4.3,43.4 0.4,43.7 7.5,35.7 4.3,35.7 \t\t\t"
      })
    ]),
    /*#__PURE__*/_createElementVNode("g", { class: "st0 lane-4" }, [
      /*#__PURE__*/_createElementVNode("polygon", {
        class: "st1",
        points: "43.7,35.7 40.5,35.7 47.6,43.7 52.3,43.4 \t\t\t"
      }),
      /*#__PURE__*/_createElementVNode("polygon", {
        class: "st1",
        points: "-4.3,43.4 0.4,43.7 7.5,35.7 4.3,35.7 \t\t\t"
      })
    ]),
    /*#__PURE__*/_createElementVNode("g", { class: "st0 lane-5" }, [
      /*#__PURE__*/_createElementVNode("polygon", {
        class: "st1",
        points: "43.7,35.7 40.5,35.7 47.6,43.7 52.3,43.4 \t\t\t"
      }),
      /*#__PURE__*/_createElementVNode("polygon", {
        class: "st1",
        points: "-4.3,43.4 0.4,43.7 7.5,35.7 4.3,35.7 \t\t\t"
      })
    ])
  ])
], -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { id: "bus" }, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "st1 wheel right",
    d: "M31.7,36.5h-2.3c-0.7,0-1.2-0.5-1.2-1.2v-2.8H33v2.8C32.9,36,32.3,36.5,31.7,36.5z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "st1 wheel left",
    d: "M18.6,36.5h-2.3c-0.7,0-1.2-0.5-1.2-1.2v-2.8h4.8v2.8C19.8,36,19.3,36.5,18.6,36.5z"
  }),
  /*#__PURE__*/_createElementVNode("g", { class: "bus-body" }, [
    /*#__PURE__*/_createElementVNode("path", {
      class: "st1",
      d: "M12.4,14.5v0.9v0.7h-1c-1,0-1.8,0.8-1.8,1.8v6c0,1,0.8,1.8,1.8,1.8h1V27v2.8c0,2.2,1.8,3.9,3.9,3.9h15.3\n\t\t\tc2.2,0,3.9-1.8,3.9-3.9V27v-1.4h1c1,0,1.8-0.8,1.8-1.8v-6c0-1-0.8-1.8-1.8-1.8h-1v-0.8V13c0-0.3-0.3-0.7-0.7-0.7\n\t\t\tc-0.3,0-0.7,0.3-0.7,0.7v2.3H13.7v-0.8l0,0l0,0c0-1.4,1.2-2.6,2.6-2.6l0,0l0,0h13.9l0,0c0.3,0,0.7-0.3,0.7-0.7s-0.3-0.7-0.7-0.7\n\t\t\th-9.4L23.5,8c0.2-0.2,0.3-0.7,0-1c-0.2-0.2-0.7-0.2-1,0L19,10.4l-0.1,0.1h-2.5C14.1,10.5,12.4,12.4,12.4,14.5L12.4,14.5z"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      class: "st2",
      d: "M34.3,29.9c0,1.4-1.2,2.6-2.6,2.6H16.3c-1.4,0-2.6-1.2-2.6-2.6V27h20.6V29.9z"
    }),
    /*#__PURE__*/_createElementVNode("polygon", {
      class: "st2",
      points: "13.7,16.7 34.3,16.7 34.3,25.6 13.7,25.6 13.7,25.6 \t\t"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      class: "st2",
      d: "M37,23.9c0,0.2-0.2,0.4-0.4,0.4h-1v-6.9h1c0.2,0,0.4,0.2,0.4,0.4V23.9z"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      class: "st2",
      d: "M11.4,24.3c-0.2,0-0.4-0.2-0.4-0.4v-6c0-0.2,0.2-0.4,0.4-0.4h1v6.9C12.4,24.3,11.4,24.3,11.4,24.3z"
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      class: "st1",
      cx: "17.2",
      cy: "29.7",
      r: "1.3"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      class: "st1",
      d: "M32.1,29.7c0,0.7-0.5,1.3-1.3,1.3c-0.7,0-1.3-0.5-1.3-1.3c0-0.7,0.5-1.3,1.3-1.3C31.6,28.4,32.1,29,32.1,29.7\n\t\t\tz"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      class: "st2",
      d: "M31.6,11.9H16.4c-1.5,0-2.6,1.2-2.6,2.6v0.8h20.6v-0.8C34.3,13.1,33.1,11.9,31.6,11.9z"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "bus-stop--location",
    onClick: $setup.onClickMainCardButton
  }, [
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        ($props.shouldShowFront)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (!$props.isBusRunning)
                ? (_openBlock(), _createBlock($setup["InlineSvg"], {
                    key: 0,
                    class: "stop-bus-icon",
                    src: require('@/assets/icons/bus.svg'),
                    alt: ""
                  }, null, 8 /* PROPS */, ["src"]))
                : (_openBlock(), _createElementBlock("svg", _hoisted_2, [..._hoisted_5]))
            ]))
          : (_openBlock(), _createBlock($setup["InlineSvg"], {
              key: 1,
              class: "x-icon",
              src: require('@/assets/icons/x-icon.svg'),
              alt: ""
            }, null, 8 /* PROPS */, ["src"]))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}